<template>
  <el-dialog
    custom-class="saas-web-dialog"
    :visible.sync="dialogVisible"
    center
    :close-on-press-escape="false"
    :close-on-click-modal="false"
    :title="title"
    @close="handleClose"
  >
    <div class="dialog-content">
      <slot name="content"></slot>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: "",
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    show: {
      immediate: true,
      handler(val) {
        console.log(val, "====");
        this.dialogVisible = val;
      },
    },
  },
  data() {
    return {
      dialogVisible: false,
    };
  },
  methods: {
    handleClose() {
      this.dialogVisible = false;
      this.$emit("cancel");
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .saas-web-dialog.el-dialog {
  margin: 0 auto !important;
  top: 50%;
  transform: translateY(-50%);
  width: 380px;
  min-height: 220px;
  background: #ffffff;
  border-radius: 18px;
  .el-dialog__header {
    padding-top: 24px;
    padding-bottom: 12px;
    text-align: center;
  }
  .el-dialog__title {
    font-weight: 500;
    font-size: 14px;
    color: $saas-text-color;
  }
  .el-dialog__body {
    padding: 0 24px;
  }
  .el-dialog__close {
    font-weight: bold;
  }
}
</style>
